module.exports = __webpack_public_path__ + "static/CorprateHp_09-29ca9cd56279bd3645673bdc92615fd7.jpg";